import { blue02, blue10, blue20 } from '../../../colors/blue';
import { gray50, gray60, gray95 } from '../../../colors/gray';
import { neutral60opacity10 } from '../../../colors/neutral';
import { red02 } from '../../../colors/red';
import { rem } from '../../../utils/rem';
export var MuiCheckbox = {
    styleOverrides: {
        root: {
            backgroundColor: neutral60opacity10,
            border: "".concat(rem(1), " solid ").concat(gray50),
            color: gray60,
            '&[class*=Mui-focusVisible]': {
                boxShadow: "0 0 0 2px ".concat(blue02),
            },
            '&[class*=Mui-checked]': {
                backgroundColor: blue20,
                color: gray95,
                '&:hover': {
                    backgroundColor: blue10,
                },
            },
            '& .MuiCheckbox-indeterminateIcon': {
                backgroundColor: blue20,
            },
            '&:hover .MuiCheckbox-indeterminateIcon': {
                backgroundColor: blue10,
            },
            '&[class*=Mui-error]': {
                border: "".concat(rem(1), " solid ").concat(red02),
                '&[class*=Mui-checked]': {
                    backgroundColor: red02,
                    '&:hover': {
                        backgroundColor: red02,
                    },
                },
                '& .MuiCheckbox-indeterminateIcon': {
                    backgroundColor: red02,
                },
                '&:hover .MuiCheckbox-indeterminateIcon': {
                    backgroundColor: red02,
                },
            },
        },
    },
};
